import lodashMerge from 'lodash-es/merge';
import { merge as localMerge } from '../objectMerge';
import { flighted } from '../flighted';

export const merge: typeof localMerge = flighted(localMerge, lodashMerge);
